import { atom, selector } from "recoil"
import { BadgeModel } from "../../atoms/badges/types"
import { searchSort } from "../../../util/searh-sort"

export const taggedBadgesAtom = atom<BadgeModel[]>({
  key: "taggedBadgesAtom",
  default: []
})

export const taggedBadgesFilterState = atom<{
  textField: string
  optionSort: string
}>({
  key: "taggedBadgesFilterState",
  default: {
    textField: "",
    optionSort: ""
  }
})

export const taggedBadgesListSelector = selector({
  key: "taggedBadgesSelector",
  get: ({ get }) => {
    const list = get(taggedBadgesAtom)
    const value = get(taggedBadgesFilterState)

    const taggedBadgesList = [...list].sort(searchSort(value))

    if (value.textField.length > 0) {
      return taggedBadgesList.filter(badge => {
        return badge.title.toLowerCase().match(value.textField.toLowerCase())
      })
    } else {
      return taggedBadgesList
    }
  }
})
